export function DownloadIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.7627 0.900093V7.04072L7.10254 4.69306L7.81348 5.39619L4.25488 8.94697L0.704102 5.39619L1.39941 4.69306L3.74707 7.04072V0.900093H4.7627Z"
        fill="currentColor"
      />
      <rect y="9.90009" width="8" height="1.2" fill="currentColor" />
    </svg>
  );
}
